import { defineMessages } from 'react-intl';

export default defineMessages({
  interest: { defaultMessage: 'Interest (APY)' },
  interestRateType: { defaultMessage: 'Interest rate type' },
  stable: { defaultMessage: 'Stable' },
  variable: { defaultMessage: 'Variable' },
});
